import {
    IMPERFECT_THEME_BODY_CLASS,
    IMPERFECT_THEME_DOMAIN,
    MISFITS_THEME_BODY_CLASS,
    MISFITS_THEME_DOMAIN,
} from 'constants/theme';
import Pill from 'honeydew/Pill';
import useGlobalStore from 'hooks/useGlobalStore';

const bodyClasses = {
    [IMPERFECT_THEME_DOMAIN]: IMPERFECT_THEME_BODY_CLASS,
    [MISFITS_THEME_DOMAIN]: MISFITS_THEME_BODY_CLASS,
};

function DevBar() {
    const { setTheme, theme } = useGlobalStore();

    const onThemeClick = (overrideTheme) => {
        setTheme(overrideTheme);
        document.body.classList.remove(bodyClasses[theme]);
        document.body.classList.add(bodyClasses[overrideTheme]);
    };

    return (
        <div className="width-[200px] fixed bottom-0 right-0 z-50 flex gap-5 border-l border-t border-dashed bg-white p-15">
            <Pill
                as="button"
                variant={theme === IMPERFECT_THEME_DOMAIN ? 'active' : 'default'}
                onClick={() => onThemeClick(IMPERFECT_THEME_DOMAIN)}
            >
                IF theme
            </Pill>
            <Pill
                as="button"
                variant={theme === MISFITS_THEME_DOMAIN ? 'active' : 'default'}
                onClick={() => onThemeClick(MISFITS_THEME_DOMAIN)}
            >
                MM theme
            </Pill>
        </div>
    );
}

export default DevBar;
